import { TextField, InputAdornment } from '@mui/material';
import { Email } from '@mui/icons-material';

const EmailField = ({ emailRef, defaultValue = '' }) => {
  return (
      <TextField
        autoFocus
        margin="normal"
        variant="outlined"
        id="email"
        type="email"
        label="Email Address"
        fullWidth
        required
        inputRef={emailRef}
        defaultValue={defaultValue}
        InputProps={{
          startAdornment: (
            <InputAdornment
              position="start"
              sx={{
                '& .MuiSvgIcon-root': {
                  fontSize: '20px',
                  color: '#777', // Default color
                  transition: 'color 0.3s ease', // Smooth transition
                },
                '.Mui-focused & .MuiSvgIcon-root': {
                  color: '#1976d2 !important', // Custom color on focus
                },
              }}
            >
              <Email />
            </InputAdornment>
          ),
          sx: {
            height: '50px',
            borderRadius: '25px', // Rounded corners
          },
        }}
        sx={{
          
          '& fieldset': {
            borderRadius: '25px', // Ensures the border itself is rounded
          },
          '& input': {
            backgroundColor: 'transparent !important', // Prevents blue autofill background
            WebkitBoxShadow: '0 0 0px 1000px white inset !important', // Overrides autofill styling
          },
          '& input:autofill': {
            backgroundColor: 'transparent !important',
            WebkitBoxShadow: '0 0 0px 1000px white inset !important',
          },
          '&:hover fieldset': {
            borderColor: '#1976d2', // Changes border color on hover
          },
          '&.Mui-focused fieldset': {
            borderColor: '#1976d2', // Changes border color when focused
          },
        }}
      />
   
  );
};

export default EmailField;